class Form {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
		$(document).on('submit', '.wpcf7-form', function(){
			const hash = window.location.hash;

			if (hash) {
				sessionStorage.setItem('cf7_anchor', hash);
			}
		});

		// 戻った時に復元
		const hash = sessionStorage.getItem('cf7_anchor');

		if (hash) {
			const $target = $(hash);

			if ($target.length) {
				$('html, body').scrollTop($target.offset().top);
			}

			sessionStorage.removeItem('cf7_anchor');
		}

		$(document).on('click', '.p-reservation-confirm .wpcf7-previous', function(e){

			e.preventDefault();
		
			const referer = document.referrer;
			if (!referer) return;
		
			location.href = referer.split('#')[0] + '#c-anchor-form';
		
		});

		$(document).on('wpcf7beforesubmit', function (e) {
			const form = e.target;
		
			// 二重クリック防止（送信直前）
			if ($(form).data('submitting')) {
				e.preventDefault();
				return false;
			}
		
			$(form).data('submitting', true);
		});
		
		$(document).on('wpcf7submit', function (e) {
			const form = e.target;
		
			if (e.originalEvent.detail.status === 'mail_sent') {
				const $btn = $(form).find('[type="submit"]');
		
				$btn.prop('disabled', true).val('送信済み');
			} else {
				$(form).data('submitting', false);
			}
		});

		// $(document).on('submit', '.wpcf7 form', function(e){

		// 	if ($(this).data('submitting')) {
		// 		e.preventDefault();
		// 		return false;
		// 	}
	
		// 	$(this).data('submitting', true);
	
		// 	const $btn = $(this).find('[type="submit"]');
		// 	if ($btn.length) {
		// 		$btn.prop('disabled', true).val('送信中...');
		// 	}
	
		// });
	}
}